export async function getLeftMenuData(role, isSA) {
  const superUserMenu = [
    {
      title: 'Facility',
      key: 'Facility',
      icon: 'medicine-box',
      url: '/facility/manage',
      testid: 'nav-facility',
    },
    {
      title: 'Users',
      key: 'users',
      icon: 'user',
      url: '/users/manage',
      testid: 'nav-users',
    },
    {
      title: 'Devices',
      key: 'devices',
      icon: 'hdd',
      url: '/devices/manage',
      testid: 'nav-device',
    },
    {
      title: 'Medical Group',
      key: 'medical_group',
      icon: 'team',
      url: '/group/manage',
      testid: 'nav-group',
    },
  ]

  const menu = []
  if (role === 'Superadmin' || isSA) {
    return superUserMenu
  }
  if (role === 'Provider') {
    return []
  }
  if (role === 'Clinic') {
    return []
  }
  return menu
  // return role === 'Superadmin' ? superAdminMenu : adminMenu
}
export async function getTopMenuData() {
  return [
    {
      title: 'Settings',
      key: 'settings',
      icon: 'icmn icmn-cog utils__spin-delayed--pseudo-selector',
    },
    {
      title: 'Docs',
      key: 'documentation',
      url: 'https://docs.cleanuitemplate.com/react/getting-started',
      target: '_blank',
      icon: 'icmn icmn-books',
    },
    {
      title: 'Dashboards',
      key: 'dashboards',
      icon: 'icmn icmn-stack',
      children: [
        {
          title: 'Dashboard Alpha',
          key: 'dashboardAlpha',
          url: '/dashboard/alpha',
        },
      ],
    },
  ]
}
